import { LayoutRegisterOptions, ModelFieldType, ViewType, registerLayout } from '@kunlun/dependencies';

function registerMultiLayout(params: LayoutRegisterOptions[]) {
  params.forEach((i) => {
    registerLayout(
      `
      <view type="TABLE">
        <view type="SEARCH">
            <element widget="search" slot="search" slotSupport="field" />
        </view>
        <element widget="actionBar" slot="actionBar" slotSupport="action">
            <xslot name="actions" slotSupport="action" />
        </element>
        <element widget="CustomTableWidget" slot="table">
            <element widget="expandColumn" slot="expandRow" />
            <xslot name="fields" slotSupport="field" />
            <element widget="rowActions" slot="rowActions" />
        </element>
      </view>
          `,
      { ...i }
    );
  });
}

registerMultiLayout([
  {
    model: 'deli.aries.promotion.DeliAriesActivityItemTplDetail',
    viewType: ViewType.Table,
    inline: true
  }
]);
